module.exports = __webpack_public_path__ + "static/avida-f71da901e12100738975a559a0dc74c2.png";